var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lee-luck-draw"},[_c('div',{staticClass:"lee-luck-draw-layout",style:('width:' + _vm.config.width + 'px;height:' + _vm.config.height + 'px')},[_c('div',{ref:"allBg",class:{
        bgcolor: !_vm.config.backgroundImage,
        bgimg: _vm.config.backgroundImage
      },style:('transform:rotate(' +
          (_vm.degBg * 180) / Math.PI +
          'deg);--w:' +
          _vm.config.width +
          'px;--h:' +
          _vm.config.height +
          'px;--bg:' +
          _vm.whichBg)},[(_vm.config.backgroundImage)?_c('img',{staticClass:"bcimg",attrs:{"src":_vm.config.backgroundImage}}):_vm._e(),_c('div',{staticClass:"lee-luck-draw-prizes",style:('transform:rotate(' + (_vm.degPrizes * 180) / Math.PI + 'deg)')},[_c('canvas',{ref:"luckDraw",attrs:{"width":_vm.config.width - 2 * _vm.config.padding,"height":_vm.config.height - 2 * _vm.config.padding}}),(_vm.prizes[0].fonts)?_c('div',{staticClass:"prizes",style:('width:' +
              (_vm.config.width - 2 * _vm.config.padding) +
              'px;height:' +
              (_vm.config.height - 2 * _vm.config.padding) +
              'px')},[_c('div',{staticClass:"prizesn"},_vm._l((_vm.prizes),function(item,xh){return _c('div',{key:xh,staticClass:"ge",style:('height:' +
                  (_vm.config.width - 2 * _vm.config.padding) / 2 +
                  'px;transformOrigin:0 ' +
                  (_vm.config.width - 2 * _vm.config.padding) / 2 +
                  'px;transform:translateX(-50%) rotate(-' +
                  ((xh * _vm.perGe * 180) / Math.PI + 22.5) +
                  'deg)')},[_c('div',{staticClass:"text",style:('color:' +
                    _vm.config.fontColor +
                    ';fontSize:' +
                    _vm.config.fontSize +
                    ';bottom:' +
                    item.fonts.top)},[_vm._v("\n                "+_vm._s(item.fonts.text)+"\n              ")]),_c('div',{directives:[{name:"width",rawName:"v-width"}],staticClass:"img",style:('bottom:' + item.imgs.top),attrs:{"data-scale":item.imgs.width}},[_c('img',{attrs:{"src":item.imgs.src,"width":item.imgs.width}})])])}),0)]):_vm._e()])]),_c('div',{staticClass:"btntextw",style:('width:' +
          (_vm.config.width - 2 * _vm.config.padding) +
          'px;height:' +
          (_vm.config.height - 2 * _vm.config.padding) +
          'px')},[_c('div',{staticClass:"btntext",on:{"click":_vm.beginDraw}},[_c('div',{staticClass:"btn",style:('width:' +
              _vm.btnConfig.width +
              'px;height:' +
              _vm.btnConfig.width +
              'px;background:' +
              _vm.btnConfig.background)},[(!_vm.btnConfig.imgs)?_c('div',{staticClass:"arrow",style:('--w:' + _vm.btnConfig.width / 2 + ';--bc:' + _vm.btnConfig.background)}):_vm._e()]),_vm._l((_vm.btnConfig.imgs),function(item,index){return _c('div',{directives:[{name:"width",rawName:"v-width"}],key:index,staticClass:"img",style:('bottom:' + item.top),attrs:{"data-scale":item.width}},[_c('img',{attrs:{"src":item.src,"width":item.width}})])}),_vm._l((_vm.btnConfig.fonts),function(item,index){return _c('div',{key:index,staticClass:"text",style:('color:' +
              item.fontColor +
              ';fontSize:' +
              item.fontSize +
              ';lineHeight:' +
              item.fontSize +
              ';bottom:' +
              item.top),domProps:{"innerHTML":_vm._s(item.text)}})})],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }